import React from 'react';
import { NavLink } from 'react-router-dom';
import * as S from './TabsItem.styled';
export const TabsItem = ({ label, to }) => {
    return (React.createElement(S.Container, { as: NavLink, to: to }, label));
};
